import * as actionType from "../actions/actionType";

const initialState: any = {
  searchCount: "",
  // filterDay: "7",
  productFilter: [],
  brandFilter: [],
  gmvFilter: [],
  tableList: [],
  createTimeStart: "",
  createTimeEnd: "",
  loading: false,
  pageNum: 1,
  pageSize: 10,
  sharePageNum: 1,
  sharePageSize: 500,
  shareTableListTotal: 10,
  tableListTotal: 0,
  cateList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SUPPLIER_UPDATE_STATE:
      if (action.payload.isSetLocalStorage) {
        const localStorageData = localStorage.getItem("searchData");
        if (localStorageData) {
          const localStorageDataObj = JSON.parse(localStorageData);
          const newData = {
            ...localStorageDataObj,
            ...action.payload.obj,
          };
          localStorage.setItem("searchData", JSON.stringify(newData));
        } else {
          localStorage.setItem(
            "searchData",
            JSON.stringify(action.payload.obj),
          );
        }
      }
      return {
        ...state,
        ...action.payload.obj,
      };
    case actionType.SUPPLIER_RESET_STATE:
      return {
        searchCount: "",
        // filterDay: "7",
        productFilter: state.productFilter,
        brandFilter: state.brandFilter,
        gmvFilter: state.gmvFilter,
        tableList: state.tableList,
        createTimeStart: state.createTimeStart,
        createTimeEnd: state.createTimeEnd,
        loading: state.loading,
        pageNum: state.pageNum,
        pageSize: state.pageSize,
        tableListTotal: state.tableListTotal,
        sharePageNum: state.sharePageNum,
        sharePageSize: state.sharePageSize,
        shareTableListTotal: state.shareTableListTotal,
        cateList: state.cateList,
        templateId: state.templateId,
      };

    default:
      return state;
  }
};
